import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import PaymentPlanInstallmentRequests from './component';
import { closeNotification, showModalNotification, showPageNotification } from '@common/actions/NotificationActions';
import { createPaymentPlanRequest, getLandlordStatus } from '@rental-manager/actions/requests';
import { checkRequestActionSuccess } from '@common/paymentsUtils/api';
import { DEFAULT_ERROR, PAYMENT_PLAN_REQUEST_SUCCESS } from '@rental-manager/constants/NotificationConstants';
import FeaturePermissionTypes from '@rental-manager/constants/FeaturePermissionTypes';
import { logError } from '@zg-rentals/log-error';
import { SendNotificationWebApiHandler_sendNotification } from '@zg-rentals/ts-rent-payment-client';

const mapStateToProps = (state) => {
  const { currentTerm, nextTerm, featurePermissions } = state.payments.landlord.property;

  const { rentTermsKey, tenantName, nextPaymentPlanInstallmentNumber } = currentTerm;
  const paymentPlanFeaturePermissions =
    featurePermissions[rentTermsKey][FeaturePermissionTypes.RENTAL_PROTECTION_PAYMENT_PLAN];
  const rentTermsKeyArray = [rentTermsKey];
  const tenantNameArray = [tenantName];
  const paymentPlanInstallmentNumber = {};
  paymentPlanInstallmentNumber[rentTermsKey] = nextPaymentPlanInstallmentNumber;

  if (nextTerm.rentTermsKey) {
    rentTermsKeyArray.push(nextTerm.rentTermsKey);
    tenantNameArray.push(nextTerm.tenantName);
    paymentPlanInstallmentNumber[nextTerm.rentTermsKey] = nextTerm.nextPaymentPlanInstallmentNumber;
  }

  return {
    rentTermsKeyArray,
    tenantNameArray,
    paymentPlanFeaturePermissions,
    paymentPlanInstallmentNumber,
  };
};

export const mapDispatchToProps = (dispatch, { baseUrl, propertyId }): Record<string, any> => ({
  onSubmit: async ({ rentTermsKey, amount, type, notes }) => {
    try {
      await dispatch(closeNotification());
      const response = await dispatch(
        createPaymentPlanRequest({
          propertyId,
          rentTermsKey,
          amount,
          type,
          notes,
        }),
      );
      await checkRequestActionSuccess(response);
      return {
        success: true,
        requestKeys: response.payload?.data?.requestKeys,
      };
    } catch (err) {
      logError({ error: err });
      await dispatch(showModalNotification(DEFAULT_ERROR));
      return { error: true };
    }
  },
  onClose: (paymentPlanRequested, tenantName, requestKeysCollection) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(
        () =>
          paymentPlanRequested &&
          SendNotificationWebApiHandler_sendNotification({
            resourceId: propertyId,
            notificationType: 'ireneMultiplePaymentPlanInstallments',
            data: JSON.stringify(requestKeysCollection),
          }),
      )
      .then(
        () =>
          paymentPlanRequested &&
          SendNotificationWebApiHandler_sendNotification({
            resourceId: propertyId,
            notificationType: 'rachelMultiplePaymentPlanInstallments',
            data: JSON.stringify(requestKeysCollection),
          }),
      )
      .then(() => dispatch(push(baseUrl)))
      .then(() => dispatch(getLandlordStatus({ propertyId })))
      .then(checkRequestActionSuccess)
      .then(() => paymentPlanRequested && dispatch(showPageNotification(PAYMENT_PLAN_REQUEST_SUCCESS, { tenantName })))
      .catch((err) => {
        logError({ error: err });
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPlanInstallmentRequests);
